/**
 * Fuse search keys for filter value options. `value` covers items whose value
 * is the display string, while `text` / `badge.text` cover list items (e.g.
 * tag badges) whose `value` is a typed object — without these, Fuse stringifies
 * the object to "[object Object]" and the display name is not searchable.
 */
export const ARRAY_STRING_FILTER_SEARCH_KEYS = ["value", "text", "badge.text"];

/**
 * Selected values lead the dropdown only while the search box is empty. Once
 * the merchant types, the search matches lead instead, and selected values
 * that don't match stay at the end of the list, where
 * `mergeSelectedListItems` appends them.
 */
export function shouldSortSelectedFirst(searchText: string): boolean {
  return searchText.trim() === "";
}
